import { Exception } from 'src/app/core/logic/exception';

export class DietitianNotFoundException extends Exception<never> {
  constructor() {
    super('Diététicien non trouvé');
  }
}
